import { Component, OnInit } from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as _ from 'lodash';
import { ProductoService } from '../../../services/producto/producto.service';
import { PreviewFantasyCategoryService } from '../../../services/preview-fantasy-category/preview-fantasy-category.service';
import { Producto } from '../../../../model/class/Producto';
import { Archivo } from '../../../../model/class/Archivo';
import { Categoria } from '../../../../model/class/Categoria';
import { CategoriaProducto } from '../../../../model/class/CategoriaProducto';
import { ConfirmService } from '../../../services/confirm/confirm.service';
import { ImageResizeService } from '../../../services/image-resize.service';
import { FileUploader } from 'ng2-file-upload';
import { APP_CONTS } from '../../../app.constants';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CategoriaService } from '../../../services/categoria/categoria.service';

const TYPE_BANNER = 'CAT_ESP_BANNER';
const TYPE_IMG_GALLERY = 'CAT_ESP_IMAGEN_GALERIA';
const TYPE_VIDEO_GALLERY = 'CAT_ESP_VIDEO_GALERIA';
const TYPE_CATALOGO = 'CAT_ESP_CATALOGO';
const TYPE_IMG_VERTICAL = 'CAT_ESP_IMAGEN_ANEXA_VAERTICAL';
const TYPE_IMG_HORIZONTAL = 'CAT_ESP_IMAGEN_ANEXA_HORIZONTAL';

@Component({
  selector: 'app-crear-categoria-especial',
  templateUrl: './crear-categoria-especial.component.html',
  styleUrls: ['./crear-categoria-especial.component.css'],
  providers: [DragulaService]
})
export class CrearCategoriaEspecialComponent implements OnInit {

  loaders = {
    guardar: false,
    eliminar: false,
    portada: false,
    search: true,
    banners: false,
    catalogo: false,
    galeria: false,
    imgVerticales: false,
    imgHorizontales: false,
  };

  bags = {
    portada: 'bag-portada',
    productos: 'bag-productos',
    banners: 'bag-banners',
    catalogo: 'bag-catalogo',
    galeria: 'bag-galeria',
    imgVerticales: 'bag-img-verticales',
    imgHorizontales: 'bag-img-horizontales',
  };

  // nameFileCatalogo: string;

  categoria = new Categoria({esFantasia: true, publicada: 1, orden: 0, posicionGaleria: 0, ordenFantasia: 0});

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;
  docFormat = APP_CONTS.FILES.DOC_FORMAT_STR;
  contIdsNuevos = -1;

  prodBuscados: CategoriaProducto[] = [];
  prodBorrados: CategoriaProducto[] = [];

  bannersSeleccionados: Archivo[] = [];
  bannersBorrados: Archivo[] = [];
  catalogosBorrados: Archivo[] = [];

  imgGaleriaSeleccioandas: Archivo[] = [];
  imgGaleriaBorradas: Archivo[] = [];
  imgHorizontalesBorradas: Archivo[] = [];
  imgVerticalesBorradas: Archivo[] = [];

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();


  elementos: {
    tipo: string,
    data?: Archivo | CategoriaProducto | any
  }[] = [];

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.CAT_ESP_FORMAT
  });


  public dropZoneOver = {
    portada: false,
    productos: false,
    banners: false,
    catalogo: false,
    galeria: false,
    imgVerticales: false,
    imgHorizontales: false,
  };


  public fileOverBase(e: any, tipo: string): void {
    switch (tipo) {
      case this.bags.portada: {
        this.dropZoneOver.portada = e;
        break;
      }
      case this.bags.productos: {
        this.dropZoneOver.productos = e;
        break;
      }
      case this.bags.banners: {
        this.dropZoneOver.banners = e;
        break;
      }
      case this.bags.catalogo: {
        this.dropZoneOver.catalogo = e;
        break;
      }
      case this.bags.galeria: {
        this.dropZoneOver.galeria = e;
        break;
      }
      case this.bags.imgVerticales: {
        this.dropZoneOver.imgVerticales = e;
        break;
      }
      case this.bags.imgHorizontales: {
        this.dropZoneOver.imgHorizontales = e;
        break;
      }
    }
  }

  constructor(
    private router: Router,
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
    private confirmService: ConfirmService,
    private productoService: ProductoService,
    private imageResizeService: ImageResizeService,
    private previewFantasyCategoryService: PreviewFantasyCategoryService,
    private activatedRoute: ActivatedRoute,
    private categoriaService: CategoriaService,
  ) {

    this.dragulaService.dropModel.subscribe((value) => {
      switch (value[0]) {
        case 'elemetns-bag': {
          this.emparejarOrdenElementos();
          break;
        }
        case this.bags.banners: {
          this.emparejarOrdenArchivos(this.bags.banners);
          break;
        }
        case this.bags.galeria: {
          this.emparejarOrdenArchivos(this.bags.galeria);
          break;
        }
      }

    });

    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();

        if (this.textoBuscar === '') {
          this.prodBuscados = [];
        } else {
          this.buscarProducto();
        }
      });

    this.activatedRoute.params.subscribe( params => {
      if (parseInt(params.id, 0) !== 0) {
        this.categoria.id = parseInt(params.id, 0);
        if (this.previewFantasyCategoryService.categoria && (this.previewFantasyCategoryService.categoria.id === this.categoria.id)) {
          this.getPreviewData();
        } else {
          this.ngLoadData();
        }
      } else if (this.previewFantasyCategoryService.categoria && !this.previewFantasyCategoryService.categoria.id) {
        this.getPreviewData();
      }
    });
  }

  ngOnInit() {}

  ngLoadData() {
    const observeProductos = this.categoriaService.getProductosPivote(this.categoria.id);
    const observeArchivos =  this.categoriaService.getArchivos(this.categoria.id);
    const observeCategoria =  this.categoriaService.get(this.categoria.id);
    forkJoin([observeProductos, observeArchivos, observeCategoria])
      .subscribe(data => {

        const auxProd = [];
        const auxArchivos = [];

        for (const pivot of data[0]) {
          const aux = {
            tipo: this.bags.productos,
            data: new CategoriaProducto(pivot)
          };
          auxProd.push(aux);
        }
        /**
         * Archivos
         * */
        const archivosTodos = data[1];

        for (const archivo of archivosTodos) {
          switch (archivo.tipo) {
            case TYPE_BANNER: {
              this.bannersSeleccionados.push(new Archivo(archivo));
              break;
            }
            case TYPE_IMG_GALLERY: {
              this.imgGaleriaSeleccioandas.push(new Archivo(archivo));
              break;
            }
            case TYPE_CATALOGO: {
              const aux = {
                tipo: this.bags.catalogo,
                data: new Archivo(archivo)
              };
              auxArchivos.push(aux);
              break;
            }
            case TYPE_IMG_VERTICAL: {
              const aux = {
                tipo: this.bags.imgVerticales,
                data: new Archivo(archivo)
              };
              auxArchivos.push(aux);
              break;
            }
            case TYPE_IMG_HORIZONTAL: {
              const aux = {
                tipo: this.bags.imgHorizontales,
                data: new Archivo(archivo)
              };
              auxArchivos.push(aux);
              break;
            }
          }
        }
        this.categoria = new Categoria(data[2]);

        let allElments = _.union(auxProd, auxArchivos);
        if (this.imgGaleriaSeleccioandas.length > 0) {
          allElments.push({
            tipo: this.bags.galeria,
            data: {orden: this.categoria.posicionGaleria}
          });
        }

        allElments = _.orderBy(allElments, 'data.orden');

        this.elementos = allElments;
        this.emparejarOrdenElementos();

      });
  }

  getPreviewData() {
    if (this.previewFantasyCategoryService.categoria) {
      this.categoria = this.previewFantasyCategoryService.categoria;
    }
    if (this.previewFantasyCategoryService.prodBorrados) {
      this.prodBorrados = this.previewFantasyCategoryService.prodBorrados;
    }
    if (this.previewFantasyCategoryService.bannersSeleccionados) {
      this.bannersSeleccionados = this.previewFantasyCategoryService.bannersSeleccionados;
    }
    if (this.previewFantasyCategoryService.bannersBorrados) {
      this.bannersBorrados = this.previewFantasyCategoryService.bannersBorrados;
    }
    if (this.previewFantasyCategoryService.catalogosBorrados) {
      this.catalogosBorrados = this.previewFantasyCategoryService.catalogosBorrados;
    }
    if (this.previewFantasyCategoryService.imgGaleriaSeleccioandas) {
      this.imgGaleriaSeleccioandas = this.previewFantasyCategoryService.imgGaleriaSeleccioandas;
    }
    if (this.previewFantasyCategoryService.imgGaleriaBorradas) {
      this.imgGaleriaBorradas = this.previewFantasyCategoryService.imgGaleriaBorradas;
    }
    if (this.previewFantasyCategoryService.imgHorizontalesBorradas) {
      this.imgHorizontalesBorradas = this.previewFantasyCategoryService.imgHorizontalesBorradas;
    }
    if (this.previewFantasyCategoryService.imgVerticalesBorradas) {
      this.imgVerticalesBorradas = this.previewFantasyCategoryService.imgVerticalesBorradas;
    }
    if (this.previewFantasyCategoryService.elementos) {
      this.elementos = this.previewFantasyCategoryService.elementos;
    }

    /**
     * Falta array de elementos
     */

  }

  activarCategoria() {
    this.categoria.publicada = 1;
  }

  desactivarCategoria() {
    this.categoria.publicada = 0;
  }

  cargarArchivo(event, tipo: string) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {

        let tipoArchivo: string;

        switch (tipo) {
          case this.bags.banners: {
            this.loaders.banners = true;
            tipoArchivo = TYPE_BANNER;
            break;
          }
          case this.bags.galeria: {
            this.loaders.galeria = true;
            tipoArchivo = TYPE_IMG_GALLERY;
            break;
          }
          case this.bags.catalogo: {
            this.loaders.catalogo = true;
            tipoArchivo = TYPE_CATALOGO;
            break;
          }
          case this.bags.imgVerticales: {
            this.loaders.imgVerticales = true;
            tipoArchivo = TYPE_IMG_VERTICAL;
            break;
          }
          case this.bags.imgHorizontales: {
            this.loaders.imgHorizontales = true;
            tipoArchivo = TYPE_IMG_HORIZONTAL;
            break;
          }
        }
        const newArchivo = new Archivo({id: this.contIdsNuevos, orden: 0, tipo: tipoArchivo, nuevo: true});
        newArchivo.file = file;

        // if (tipoArchivo !== TYPE_IMG_GALLERY) {
        let name = file.name.replace(/\_/g, ' ');
        name = name.replace(/-/g, ' ');
        name = name.substring(0, name.lastIndexOf('.'));
        newArchivo.nombre = name;
        // }

        switch (tipo) {
          case this.bags.banners: {
            this.bannersSeleccionados.push(newArchivo);
            this.emparejarOrdenArchivos(tipo);
            break;
          }
          case this.bags.galeria: {
            this.imgGaleriaSeleccioandas.push(newArchivo);
            this.emparejarOrdenArchivos(tipo);

            const index = _.findIndex(this.elementos, {tipo: tipo});

            if (index === -1) {
              this.elementos.push({
                tipo: tipo,
                data: {orden: 0}
              });
              this.emparejarOrdenElementos();
            }
            break;
          }
          case this.bags.catalogo:
          case this.bags.imgVerticales:
          case this.bags.imgHorizontales: {
            this.elementos.push({
              tipo: tipo,
              data: newArchivo
            });
            this.emparejarOrdenElementos();
          }
        }

        this.contIdsNuevos--;

        if (tipo === this.bags.catalogo) {
          this.loaders.catalogo = false;
        } else {
          this.imageResizeService.resize([file], 500, 200)
            .subscribe((result) => {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                newArchivo.previewUrl = e.target.result;
              };
              reader.readAsDataURL(result);
              switch (tipo) {
                case this.bags.banners: {
                  this.loaders.banners = false;
                  break;
                }
                case this.bags.galeria: {
                  this.loaders.galeria = false;
                  break;
                }
                case this.bags.imgVerticales: {
                  this.loaders.imgVerticales = false;
                  break;
                }
                case this.bags.imgHorizontales: {
                  this.loaders.imgHorizontales = false;
                  break;
                }
              }
            });
        }
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  quitarArchivo(archivo: Archivo, tipo: string) {

    let borrados: Archivo[];

    switch (tipo) {
      case this.bags.banners: {
        _.remove(this.bannersSeleccionados, {'id': archivo.id });
        borrados = this.bannersBorrados;
        this.emparejarOrdenArchivos(tipo);
        break;
      }
      case this.bags.galeria: {
        _.remove(this.imgGaleriaSeleccioandas, {'id': archivo.id });
        borrados = this.imgGaleriaBorradas;
        this.emparejarOrdenArchivos(tipo);

        if (this.imgGaleriaSeleccioandas.length === 0) {
          _.remove(this.elementos, {tipo: tipo});
        }
        break;
      }
      case this.bags.catalogo: {
        _.remove(this.elementos, (o) => {
          if (o.tipo === this.bags.catalogo) {
            if (o.data.id === archivo.id) {
              return o;
            }
          }
        });
        borrados = this.catalogosBorrados;
        this.emparejarOrdenElementos();
        break;
      }
      case this.bags.imgVerticales: {
        _.remove(this.elementos, (o) => {
          if (o.tipo === this.bags.imgVerticales) {
            if (o.data.id === archivo.id) {
              return o;
            }
          }
        });
        borrados = this.imgVerticalesBorradas;
        this.emparejarOrdenElementos();
        break;
      }
      case this.bags.imgHorizontales: {
        _.remove(this.elementos, (o) => {
          if (o.tipo === this.bags.imgHorizontales) {
            if (o.data.id === archivo.id) {
              return o;
            }
          }
        });
        borrados = this.imgHorizontalesBorradas;
        this.emparejarOrdenElementos();
        break;
      }
    }

    if (!archivo.nuevo) {
      borrados.push(archivo);
    }
  }

  cargarPortada(event, tipo: string) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.portada = true;
        this.categoria.nuevaImagen = file;

        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.categoria.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
            this.loaders.portada = false;
          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  onTextoBuscarChange(texto: string) {
    this.loaders.search = true;
    this.textoBuscarChanged.next(texto);
  }

  limpiarTexto () {
    this.prodBuscados = [];
    this.textoBuscar = '';
  }

  buscarProducto () {
    let texto =  this.textoBuscar.replace(new RegExp('span', 'ig'), '');
    texto = _.trim(texto);

    this.prodBuscados = [];

    if (texto) {
      const objetoBucar: any[] = [{'name': texto}];
      const parametros = {search: JSON.stringify(objetoBucar)};

      this.productoService.getPublicados(parametros)
        .subscribe( data => {
          _.each(data, (producto: Producto) => {
            const indexPublicado = _.findIndex(this.elementos, (o) => {
              if (o.tipo === this.bags.productos) {
                if (o.data.producto.id === producto.id) {
                  return o;
                }
              }
            });
            if (indexPublicado === -1) {
              this.prodBuscados.push(new CategoriaProducto({
                productoId: producto.id,
                producto: producto,
                orden: 0,
                nuevo: true
              }));
            }
          });
          this.loaders.search = false;
        });
    } else {
      this.loaders.search = false;
    }
  }

  agregarProducto(catProd: CategoriaProducto) {
    this.limpiarTexto();
    const aunx = _.clone(catProd);
    const borrados = _.remove(this.prodBorrados, {'productoId': catProd.productoId });
    if (!borrados || borrados.length === 0) {
      aunx.nuevo = true;
    }

    this.elementos.push({
      tipo: this.bags.productos,
      data: aunx
    });

    this.emparejarOrdenElementos();
  }

  quitarProducto(catProd: CategoriaProducto) {
    _.remove(this.elementos, (o) => {
      if (o.tipo === this.bags.productos) {
        if (o.data.productoId === catProd.productoId) {
          return o;
        }
      }
    });
    if (!catProd.nuevo) {
      this.prodBorrados.push(catProd);
    }
    this.emparejarOrdenElementos();
  }

  emparejarOrdenElementos() {
    _.each(this.elementos, (o, i) => {
      o.data.orden = i + 1;
      if (o.tipo === this.bags.galeria) {
        this.categoria.posicionGaleria = i;
      }
    });
  }

  emparejarOrdenArchivos(tipo: string) {

    let actuales: Archivo[];
    switch (tipo) {
      case this.bags.banners: {
        actuales = this.bannersSeleccionados;
        break;
      }
      case this.bags.galeria: {
        actuales = this.imgGaleriaSeleccioandas;
        break;
      }
    }

    _.each(actuales, (o: Archivo, i) => {
      o.orden = i + 1;
    });
  }

  cancelar() {
    this.confirmService.confirm('Cancelar',
      '¿Seguro que desea cancelar la edición/creación? Los cambios que no hayan sido guardados se perderán.')
      .then( (resp) => {
        if (resp) {
          this.previewFantasyCategoryService.borrar();
          this.toasts.success('Cambios cancelados.');
          this.router.navigate(['/administrador/admin-sitio/categorias-especiales']);
        }
      });
  }

  eliminar() {
    this.confirmService.confirm('Eliminar',
      '¿Seguro que desea eliminar esta Categoría Especial?')
      .then( (resp) => {
        if (resp) {
          this.loaders.eliminar = true;

          this.categoriaService.delete(this.categoria.id)
            .subscribe(
              (data) => {
                this.toasts.success('Categoría Especial eliminada.');
                this.router.navigate(['/administrador/admin-sitio/categorias-especiales']);
              }, (error) => {
                this.toasts.success('Problemas al eliminar la Categoría Especial.');
              }
            );


        }
      });
  }

  preview() {
    this.previewFantasyCategoryService.borrar();
    this.previewFantasyCategoryService.categoria = this.categoria;
    this.previewFantasyCategoryService.elementos = this.elementos;
    this.previewFantasyCategoryService.prodBorrados = this.prodBorrados;
    this.previewFantasyCategoryService.bannersSeleccionados = this.bannersSeleccionados;
    this.previewFantasyCategoryService.bannersBorrados = this.bannersBorrados;
    this.previewFantasyCategoryService.catalogosBorrados = this.catalogosBorrados;
    this.previewFantasyCategoryService.imgGaleriaSeleccioandas = this.imgGaleriaSeleccioandas;
    this.previewFantasyCategoryService.imgGaleriaBorradas = this.imgGaleriaBorradas;
    this.previewFantasyCategoryService.imgHorizontalesBorradas = this.imgHorizontalesBorradas;
    this.previewFantasyCategoryService.imgVerticalesBorradas = this.imgVerticalesBorradas;

    /**
     * Falta array de elementos
     */

    this.router.navigate(['/vista-previa-categoria-especial']);
  }

  onError() {
    this.loaders.guardar = false;
    this.toasts.error('Error al editar la Categoría');
  }

  guardarCambios() {

    this.loaders.guardar = true;
    const elementos = _.cloneDeep(this.elementos);
    const elemFiles: Archivo[] = [];
    const productos: CategoriaProducto[] = [];
    for (const el of elementos) {
      if (el.tipo !== this.bags.galeria) {
        if (el.tipo === this.bags.productos) {
          productos.push(el.data);
        } else {
          elemFiles.push(el.data);
        }
      }
    }
    const archivos: Archivo[] = _.union(elemFiles, this.bannersSeleccionados, this.imgGaleriaSeleccioandas);


    if (this.categoria.id) {
      /**
       * Modificados
       * Los productos modificados debo eliminarlos y crearlos nuevamente
       */
      const prodModificados = _.filter(productos, (o) => {
        if (!o.nuevo && (o.orden !== o.antiguoOrden)) {
          return o;
        }
      });
      const archivosModificados = _.filter(archivos, (o) => {
        if (!o.nuevo && (o.orden !== o.antiguoOrden)) {
          return o;
        }
      });

      /**
       * Eliminados
       */
      const archivosBorrados = _.union(
        this.bannersBorrados,
        this.imgGaleriaBorradas,
        this.imgVerticalesBorradas,
        this.imgHorizontalesBorradas);
      const productosBorrados = _.union(this.prodBorrados, prodModificados);

      /**
       * Creados
       */
      let pordCreados = _.filter(productos, {'nuevo': true});
      pordCreados = _.union(pordCreados, prodModificados);
      const archivosCreados = _.filter(archivos, {'nuevo': true});


      // Modifico la categoria

      this.categoriaService.edit(this.categoria.id, this.categoria.getFormData())
        .subscribe(
          () => {
            const promEliminados: any[] = [];
            for (const file of archivosBorrados) {
              promEliminados.push(this.categoriaService.deletaArchivo(this.categoria.id, file.id));
            }
            for (const prod of productosBorrados) {
              promEliminados.push(this.categoriaService.deleteProducto(this.categoria.id, prod.producto.id));
            }
            forkJoin(promEliminados)
              .subscribe(
                null, (error) => {
                  this.onError();
                }, () => {

                  const promMod: any[] = [];
                  for (const file of archivosModificados) {
                    promMod.push(this.categoriaService.editArchivo(this.categoria.id, file.id, file.getFormData()));
                  }

                  forkJoin(promMod)
                    .subscribe(
                      null, (error) => {
                        this.onError();
                      }, () => {
                        const promCreacion: any[] = [];
                        for (const prod of pordCreados) {
                          promCreacion.push(this.categoriaService.setProducto(this.categoria.id, prod.getFormData()));
                        }
                        for (const file of archivosCreados) {
                          promCreacion.push(this.categoriaService.setArchivo(this.categoria.id, file.getFormData()));
                        }
                        forkJoin(promCreacion)
                          .subscribe(
                            null, (error) => {
                              this.onError();
                            }, () => {
                              this.loaders.guardar = false;
                              this.toasts.success('Categoría modificada.');
                              this.router.navigate(['/administrador/admin-sitio/categorias-especiales']);
                            }
                          );
                      }
                    );
                }
              );

          }, (error) => {
            this.onError();
          }
        );

    } else {

      const promArchivos = [];
      const promProductos = [];

      this.categoriaService.create(this.categoria.getFormData())
        .subscribe(
          (resp) => {
            this.categoria = new Categoria(resp.data);
            for (const prod of productos) {
              promProductos.push(this.categoriaService.setProducto( this.categoria.id, prod.getFormData()));
            }
            forkJoin(promProductos)
              .subscribe(
                null, (error) => {
                  this.toasts.warning('La Categoría ha sido creada, pero ocurrió un error al asociar los productos y archivos.');
                }, () => {
                  for (const file of archivos) {
                    promArchivos.push(this.categoriaService.setArchivo(this.categoria.id, file.getFormData()));
                  }
                  forkJoin(promArchivos)
                    .subscribe(
                      null , (error) => {
                        this.toasts.warning('La Categoría ha sido creada, pero ocurrió un error al asociar los archivos.');
                        this.loaders.guardar = false;
                      }, () => {
                        this.loaders.guardar = false;
                        this.toasts.success('Categoría creada.');
                        this.router.navigate(['/administrador/admin-sitio/categorias-especiales']);
                      }
                    );
                }
              );
          }, (error) => {
            console.error(error);
            this.toasts.error('Error al crear la Categoría');
            this.loaders.guardar = false;
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/crear-categoria-especial/crear-categoria-especial.component.ts